/* TeeJuly Archive — theme.js (no dependencies) */
(function () {
  'use strict';
  var TJ = window.TJ || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || TJ.moneyFormat || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, dec, thou, sep) {
      dec = isNaN(dec) ? 2 : dec; thou = thou || ','; sep = sep || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(dec);
      var parts = n.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return d + (parts[1] ? sep + parts[1] : '');
    }
    var m = format.match(re); if (!m) return format;
    var v;
    switch (m[1]) {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(re, v);
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-show'); }, 2400);
  }

  /* ---------- Drawers ---------- */
  var overlay = $('[data-overlay]');
  var lastFocus = null;
  function openDrawer(name) {
    var d = $('[data-drawer="' + name + '"]'); if (!d) return;
    closeDrawers(true);
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var f = d.querySelector('button, a, input'); if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawers(silent) {
    $$('[data-drawer].is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (overlay) overlay.hidden = true;
    document.documentElement.style.overflow = '';
    if (!silent && lastFocus) { try { lastFocus.focus(); } catch (e) {} }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-drawer]');
    if (t) { e.preventDefault(); openDrawer(t.getAttribute('data-open-drawer')); return; }
    if (e.target.closest('[data-close-drawer]') || e.target === overlay) { closeDrawers(); return; }
    var c = e.target.closest('[data-open-cart]');
    if (c && TJ.cartType === 'drawer' && $('[data-drawer="cart"]')) { e.preventDefault(); openDrawer('cart'); return; }
    var s = e.target.closest('[data-open-saved]');
    if (s) { e.preventDefault(); renderSaved(); openDrawer('saved'); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Cart ---------- */
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.hidden = n === 0;
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }
  function refreshCart(open) {
    return fetch(TJ.routes.root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer']; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var cur = $('#CartDrawer');
        if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
        var cnt = doc.querySelector('[data-cart-count-source]');
        if (cnt) updateCount(parseInt(cnt.textContent, 10) || 0);
        if (open) openDrawer('cart');
      });
  }
  function addToCart(form, btn) {
    var fd = new FormData(form);
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    var err = form.querySelector('[data-form-error]'); if (err) err.hidden = true;
    return fetch(TJ.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to bag');
        if (TJ.cartType === 'page') { window.location = TJ.routes.cart; return; }
        toast(TJ.strings.added);
        return refreshCart(true);
      })
      .catch(function (e) {
        if (err) { err.textContent = e.message; err.hidden = false; } else { toast(e.message); }
      })
      .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-quick-add]') || f.matches('[data-product-form]')) {
      if (TJ.cartType === 'page' && f.matches('[data-product-form]')) return; // native submit
      e.preventDefault();
      addToCart(f, f.querySelector('[type=submit]'));
    }
  });
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty-change]');
    if (!q) return;
    var li = q.closest('[data-line]'); if (!li) return;
    e.preventDefault();
    li.style.opacity = '.5';
    fetch(TJ.routes.cartChange + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(li.getAttribute('data-line'), 10), quantity: parseInt(q.getAttribute('data-qty-change'), 10) })
    }).then(function () { return refreshCart(false); })
      .catch(function () { li.style.opacity = ''; });
  });

  /* ---------- Product card option pickers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-product-card] [data-opt]');
    if (!b) return;
    var card = b.closest('[data-product-card]');
    var idx = parseInt(b.getAttribute('data-opt'), 10);
    $$('[data-opt="' + idx + '"]', card).forEach(function (x) { x.classList.toggle('is-active', x === b); });
    var json = card.querySelector('[data-variants]'); if (!json) return;
    var variants; try { variants = JSON.parse(json.textContent); } catch (err) { return; }
    var sel = {};
    $$('[data-opt].is-active', card).forEach(function (x) { sel[x.getAttribute('data-opt')] = x.getAttribute('data-val'); });
    var match = variants.filter(function (v) {
      return Object.keys(sel).every(function (k) { return v.options[k] === sel[k]; });
    })[0];
    var input = card.querySelector('[data-quick-add] [name=id]');
    var btn = card.querySelector('[data-quick-add] [type=submit]');
    var label = btn && btn.querySelector('[data-label]');
    if (match && input) {
      input.value = match.id;
      btn.disabled = !match.available;
      if (label) label.textContent = match.available ? 'Quick add' : TJ.strings.soldOut;
    } else if (btn) {
      btn.disabled = true; if (label) label.textContent = TJ.strings.unavailable;
    }
    // mark unavailable sizes for the selected color
    var colorIdx = $('.dot[data-opt]', card) ? $('.dot[data-opt]', card).getAttribute('data-opt') : null;
    if (colorIdx !== null) {
      $$('.size-chip', card).forEach(function (chip) {
        var si = chip.getAttribute('data-opt');
        var ok = variants.some(function (v) { return v.available && v.options[si] === chip.getAttribute('data-val') && v.options[colorIdx] === sel[colorIdx]; });
        chip.classList.toggle('is-unavailable', !ok);
      });
    }
  });

  /* ---------- Product page ---------- */
  function initProduct(section) {
    var jsonEl = section.querySelector('[data-product-json]'); if (!jsonEl) return;
    var product; try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var form = section.querySelector('[data-product-form]');
    var idInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var atc = section.querySelector('[data-atc]');
    var atcLabel = section.querySelector('[data-atc-label]');
    var stock = section.querySelector('[data-stock]');
    var fieldsets = $$('fieldset[data-option-index]', section);
    var stickyPrice = $('[data-sticky-price]');

    function selected() {
      return fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function findVariant(opts) {
      return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
    }
    function markAvailability(opts) {
      fieldsets.forEach(function (fs, i) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[i] = inp.value;
          var ok = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, j) { return j === i ? o === inp.value : (j < i || fieldsets.length < 3 ? o === test[j] : true); });
          });
          inp.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function showMedia(id) {
      if (!id) return;
      var slide = section.querySelector('[data-media="' + id + '"]'); if (!slide) return;
      $$('[data-media]', section).forEach(function (s) { s.classList.toggle('is-active', s === slide); });
      $$('[data-thumb]', section).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') == id); });
      $$('[data-dot]', section).forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-dot') == id); });
      var track = section.querySelector('[data-track]');
      if (track && window.matchMedia('(max-width: 989px)').matches) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
    function update() {
      var opts = selected();
      fieldsets.forEach(function (fs, i) { var l = fs.querySelector('[data-option-label]'); if (l) l.textContent = opts[i]; });
      markAvailability(opts);
      var v = findVariant(opts);
      if (!v) {
        atc.disabled = true; atcLabel.textContent = TJ.strings.unavailable; return;
      }
      idInput.value = v.id;
      var html = '<span class="price' + (v.compare_at_price > v.price ? ' price--sale' : '') + '"><span class="price__now">' + formatMoney(v.price) + '</span>';
      if (v.compare_at_price > v.price) {
        html += '<s class="price__was">' + formatMoney(v.compare_at_price) + '</s><span class="price__save tag tag--red">Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%</span>';
      }
      priceEl.innerHTML = html + '</span>';
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? TJ.strings.addToCart + ' — ' + formatMoney(v.price) : TJ.strings.soldOut;
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (stock) stock.innerHTML = v.available ? '<i class="stock__dot"></i> In stock' : '<i class="stock__dot stock__dot--out"></i> Sold out';
      if (v.featured_media) showMedia(v.featured_media.id);
      var url = section.getAttribute('data-url');
      if (url && window.history.replaceState) window.history.replaceState({}, '', url + '?variant=' + v.id);
      // update payment terms (installments) element
      var terms = form && form.querySelector('shopify-payment-terms');
      if (terms) terms.setAttribute('variant-id', v.id);
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    if (fieldsets.length) markAvailability(selected());

    section.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]'); if (t) { showMedia(t.getAttribute('data-thumb')); return; }
      var q = e.target.closest('[data-qty]');
      if (q) {
        var inp = section.querySelector('[data-qty-input]');
        inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(q.getAttribute('data-qty'), 10));
      }
    });

    // Mobile swipe → sync dots
    var track = section.querySelector('[data-track]');
    if (track && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) {
            var id = en.target.getAttribute('data-media');
            $$('[data-dot]', section).forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-dot') == id); });
          }
        });
      }, { root: track, threshold: [0.6] });
      $$('[data-media]', track).forEach(function (s) { io.observe(s); });
    }

    // Sticky add to cart
    var sticky = $('[data-sticky-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (en) {
        var e = en[0];
        sticky.classList.toggle('is-show', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(atc);
      var sb = $('[data-sticky-btn]');
      if (sb) sb.addEventListener('click', function () {
        if (atc.disabled) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (TJ.cartType === 'page') { form.submit(); } else { addToCart(form, sb); }
      });
    }
  }
  $$('[data-product-section]').forEach(initProduct);

  /* ---------- Modals ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-modal]');
    if (o) { var m = document.getElementById(o.getAttribute('data-open-modal')); if (m && m.showModal) m.showModal(); return; }
    var c = e.target.closest('[data-close-modal]');
    if (c) { var d = c.closest('dialog'); if (d) d.close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* ---------- Copy promo code ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]'); if (!b) return;
    var code = b.getAttribute('data-copy');
    var done = function () { var s = b.querySelector('span'); if (s) { var old = s.textContent; s.textContent = TJ.strings.copied; setTimeout(function () { s.textContent = old; }, 1600); } toast(code + ' — ' + TJ.strings.copied); };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  /* ---------- Saved items (per-browser) ---------- */
  var KEY = 'tj_saved';
  function getSaved() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function setSaved(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function paintSaved() {
    var list = getSaved();
    $$('[data-save]').forEach(function (b) { b.classList.toggle('is-saved', list.indexOf(b.getAttribute('data-save')) > -1); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-save]'); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-save'); var list = getSaved(); var i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); toast('Removed from saved'); } else { list.unshift(h); toast('Saved'); }
    setSaved(list.slice(0, 40)); paintSaved();
  });
  function renderSaved() {
    var ul = $('[data-saved-list]'), empty = $('[data-saved-empty]'), count = $('[data-saved-count]');
    if (!ul) return;
    var list = getSaved();
    if (count) count.textContent = list.length ? '(' + list.length + ')' : '';
    empty.hidden = list.length > 0; ul.innerHTML = '';
    list.forEach(function (h) {
      fetch(TJ.routes.root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
        var li = document.createElement('li'); li.className = 'line-item';
        var img = p.featured_image ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=180" alt="" loading="lazy">' : '';
        li.innerHTML = '<a href="' + p.url + '" class="line-item__img">' + img + '</a><div class="line-item__info"><a href="' + p.url + '" class="line-item__title"></a><span class="line-item__price">' + formatMoney(p.price) + '</span><button type="button" class="link small muted" data-save="' + h + '">Remove</button></div>';
        li.querySelector('.line-item__title').textContent = p.title;
        ul.appendChild(li);
      }).catch(function () {});
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-saved-list] [data-save]')) setTimeout(renderSaved, 30);
  });
  paintSaved();

  /* ---------- Product recommendations ---------- */
  $$('[data-recs]').forEach(function (el) {
    var url = el.getAttribute('data-url'); if (!url) return;
    var load = function () {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recs]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; paintSaved(); }
        else { var sec = el.closest('.shopify-section'); if (sec && !el.innerHTML.trim()) sec.hidden = true; }
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(el);
    } else { load(); }
  });

  /* ---------- Filters close on outside click ---------- */
  document.addEventListener('click', function (e) {
    $$('details.filters[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  window.TJ.formatMoney = formatMoney;
  window.TJ.refreshCart = refreshCart;
})();
